<template>
  <v-card>
    <div class="header">
      <span class="title">Filtro solicitação</span>
      <v-btn
        icon
        class="close-btn"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <v-form
      ref="form"
      class="form-section"
    >
      <Separator label="Filtrar dados" />
      <section class="input-section">
        <v-autocomplete
          v-model="departurePointId"
          :items="companiesList"
          hide-details=""
          label="Loja de Origem"
          outlined
          dense
          clearable
          item-value="id"
          item-text="fantasy_name"
        />
        <v-autocomplete
          v-model="applicant"
          :items="usersList"
          label="Solicitante"
          outlined
          dense
          clearable
          hide-details=""
          item-value="id"
          item-text="name"
        />
        <v-autocomplete
          v-model="category"
          :items="listCategories"
          label="Categoria"
          outlined
          hide-details=""
          clearable
          dense
        />
        <v-autocomplete
          v-model="driver"
          :items="driversList"
          label="Motorista"
          hide-details=""
          outlined
          dense
          clearable
          item-value="id"
          item-text="name"
        />
        <v-autocomplete
          v-model="checklistStatus"
          :items="listChecklistStatus"
          hide-details=""
          item-value="value"
          item-text="text"
          label="Status de checklist"
          outlined
          dense
          clearable
        />
        <div style="display: flex; justify-content: center; margin-top: 20px;">
          <v-btn
            color="info"
            @click="handleFilter"
          >
            <span>FILTRAR</span>
            <!-- <v-progress-circular
              v-else
              color="info"
              indeterminate
            ></v-progress-circular> -->
          </v-btn>
        </div>
      </section>
    </v-form>
  </v-card>
</template>

<script>
import Separator from '@/components/Separator.vue'
import { mdiClose } from '@mdi/js'

export default {
  name: 'FilterAdmSolicitationsModal',
  components: {
    Separator,
  },
  props: {
    usersList: {
      type: Array,
      required: true,
      default: () => [],
    },
    companiesList: {
      type: Array,
      required: true,
      default: () => [],
    },
    driversList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
      },
      applicant: null,
      category: null,
      driver: null,
      checklistStatus: null,
      departurePointId: null,
      listCategories: [
        'Deslocamento comum', 'Rota consórcio', 'Rota transporte',
      ],
      listChecklistStatus: [
        { text: 'Checklist de começo de viagem', value: 'start' },
        { text: 'Checklist De fim de viagem', value: 'end' },
      ],
    }
  },
  methods: {
    async handleFilter() {
      this.$emit('updateTable', {
        created_by: this.applicant,
        category: this.category,
        driver_id: this.driver,
        checklist_status: this.checklistStatus,
        departure_point_id: this.departurePointId,
      })

      // try {
      //   const response = await axiosIns.post('/api/v1/solicitations/transport_solicitation_trip/filter', {
      //     created_by: this.applicant,
      //     category: this.category,
      //     driver_id: this.driver,
      //     checklist_status: this.checklistStatus,
      //   })

      //   console.log('Filter response:', response.data)
      // } catch (error) {
      //   this.showMessage({
      //     title: 'Erro ao registrar solicitação',
      //     text: 'Não foi possível registrar a solicitação. Por favor, tente novamente.',
      //     icon: 'error',
      //     timer: 5000,
      //   })
      // } finally {
      //   this.closeModal()
      // }

      // this.$emit('updateTable', {
      //   applicant: this.applicant,
      //   category: this.category,
      //   driver: this.driver,
      //   companies: this.companies,
      //   checklistStatus: this.checklistStatus,
      // })
    },

    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.header {
  width: 100%;
  text-align: center;
  padding-top: 30px;
}

.title {
  font-weight: 600;
  font-size: 20px;
  color: #E7E3FC;
}

.close-btn {
  position: absolute;
  right: 26px;
  top: 28px;
}

.form-section {
  padding: 20px 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.input-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
